module.exports = __webpack_public_path__ + "static/media/stepper.c5a2f7e2.png";